import { defineStore } from "#src/stores/state-wrapper.ts";
import { STEP } from "#src/constants/step.ts";

import { useStepExamSchedulingStore } from "#src/stores/step-exam-scheduling.ts";
import { useStepSignatureStore } from "#src/stores/step-signature.ts";
import { type StoreGeneric, type Pinia } from "pinia";
import { computed } from "vue";

import { type BaseStepStore } from "#src/types/StepStore.ts";

interface SignatureWaitingStep extends BaseStepStore {}

function initializeSignatureWaitingStore(
  pinia: Pinia,
  hot?: StoreGeneric
): SignatureWaitingStep {
  const step = computed(() => STEP.SIGNATURE_WAITING);
  const previous = computed(() => {
    const examScheduling = useStepExamSchedulingStore(pinia);
    return examScheduling.step;
  });

  const next = computed(() => {
    const signature = useStepSignatureStore(pinia, hot);
    return signature.step;
  });

  function $reset() {}

  return {
    $reset,
    step,
    previous,
    next,
  };
}

export const useStepSignatureWaitingStore = (
  pinia: Pinia,
  hot?: StoreGeneric
) =>
  defineStore<string, SignatureWaitingStep>("step-signature-waiting", () => {
    return initializeSignatureWaitingStore(pinia, hot);
  })(pinia, hot);
